import React from "react";
import { Tabs } from "antd";
// import MarketShareAnalysis from "./MarketShareAnalysis";
// import CustomerProfile from "./CustomerProfile";
import BranchKPIs from "./BranchKPIs";
import data from "./graphData.json";

const TabsGraphs = ({ selectedDistrict }) => {
	let { marketShare = [] } = data["graphData"][selectedDistrict];
	const items = [
		{
			key: "1",
			label: "Branch KPIs",
			children: <BranchKPIs data={marketShare} />,
		},
		{
			key: "2",
			label: "Call Center KPIs",
			children: <BranchKPIs data={marketShare} />,
		},
		{
			key: "3",
			label: "Digital Channel KPIs",
			children: <BranchKPIs data={marketShare} />,
		},
	];

	const onChange = (key) => {};
	return <Tabs defaultActiveKey="1" items={items} onChange={onChange} />;
};

export default TabsGraphs;
